export default {
  'resetpassword.maintext':
    'Per reimpostare la password, inserisci la nuova password in entrambi i campi',
  'resetpassword.retypepassword': 'Ripeti Password',
};
